function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "current",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M478 473 c-70 -3 -78 -6 -78 -23 0 -19 -8 -20 -183 -20 l-183 0 -17 -47 c-10 -26 -14 -50 -10 -54 5 -3 25 -12 46 -19 27 -9 35 -15 28 -24 -17 -20 -31 -66 -21 -66 6 0 10 7 10 15 0 24 46 65 73 65 31 0 77 -36 77 -61 0 -10 5 -19 11 -19 6 0 8 7 5 16 -5 13 -1 14 27 9 17 -4 47 -13 65 -21 37 -15 33 -20 57 66 14 52 14 23 -1 -34 -6 -24 -4 -26 25 -26 18 0 31 -5 32 -12 0 -7 7 1 15 19 16 37 49 63 82 63 29 0 72 -42 72 -71 0 -22 0 -22 14 -3 17 22 12 93 -11 167 l-15 48 -86 -3 -86 -3 -12 -45 c-7 -25 -12 -39 -13 -32 -1 7 4 33 10 58 l11 44 74 0 c43 0 74 4 74 10 0 6 -3 9 -7 8 -5 -1 -43 -4 -85 -5z m121 -74 c19 -55 16 -59 -44 -59 -45 0 -55 3 -56 18 -1 16 -2 16 -6 0 -2 -10 -11 -18 -19 -18 -17 0 -17 4 -3 53 10 37 10 37 63 37 52 0 55 -1 65 -31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502 400 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106 269 c-48 -38 -23 -109 38 -109 64 0 90 70 40 109 -15 12 -32 21 -39 21 -7 0 -24 -9 -39 -21z m78 -31 c15 -24 -3 -52 -37 -56 -33 -4 -53 28 -37 59 14 25 58 23 74 -3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 220 c0 -11 7 -20 15 -20 8 0 15 9 15 20 0 11 -7 20 -15 20 -8 0 -15 -9 -15 -20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505 278 c-27 -15 -35 -28 -35 -59 0 -55 83 -82 114 -37 21 29 20 51 -1 76 -23 26 -53 34 -78 20z m60 -58 c0 -29 -4 -36 -23 -38 -43 -6 -69 37 -40 66 7 7 24 12 38 10 21 -3 25 -8 25 -38z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514 229 c-8 -14 11 -33 25 -25 6 4 11 14 11 22 0 16 -26 19 -36 3z"
}));

var SvgVehicle16 = function SvgVehicle16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle16.2e1c1a4c.svg";
export { ForwardRef as ReactComponent };